import Vue from 'vue'

// Import always before all components
import './styles/main-begin.scss'

import Vuelidate from 'vuelidate'
import BootstrapVue from 'bootstrap-vue'
import VueCharts from 'vue-charts'

import configAxios from '@/configAxios'
import App from './App'
import router from './router'
import { store } from './store'
import Loading from '../components/Loading'

// Import always after all components
import './styles/main-end.scss'
import VueI18n from 'vue-i18n'
import translations from './i18n'

Vue.config.productionTip = !process.env.APP_DEBUG

store.dispatch('loadUsersCash')

configAxios(store)

Vue.use(VueI18n)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueCharts)
Vue.component('loading', Loading)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n: new VueI18n({
    locale: 'en',
    messages: translations,
    fallbackLocale: 'en',
  }),
  render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/-service-app/main.js